import { render, staticRenderFns } from "./GesSolicitudPrincipal.vue?vue&type=template&id=fe48e9d8&scoped=true&"
import script from "./GesSolicitudPrincipal.vue?vue&type=script&lang=js&"
export * from "./GesSolicitudPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./GesSolicitudPrincipal.vue?vue&type=style&index=0&id=fe48e9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe48e9d8",
  null
  
)

export default component.exports